import { Link } from 'react-router';
import type { Idioma } from '../../i18n/index.js';

const TEXTOS = {
  es: {
    autores: 'Para autores y editores',
    privacidad: 'Privacidad',
    terminos: 'Términos',
    aviso: 'Aviso legal',
  },
  en: {
    autores: 'For authors and publishers',
    privacidad: 'Privacy',
    terminos: 'Terms',
    aviso: 'Legal notice',
  },
} as const;

/**
 * Pie de todas las pantallas. Privacidad, términos y aviso legal tienen que poder alcanzarse sin
 * escribir la URL. Quién hace Athena ya lo dice la cabecera («Athena de Sinapser»).
 */
export function Pie({ idioma }: { readonly idioma: Idioma }) {
  const t = TEXTOS[idioma];
  return (
    <footer className='flex flex-wrap justify-end gap-x-4 gap-y-1 px-4 py-[22px] text-[11.5px] text-(--ink-faint) sm:px-10'>
      <Link to='/autores-y-editores' className='underline hover:text-(--ink)'>
        {t.autores}
      </Link>
      <Link to='/privacidad' className='underline hover:text-(--ink)'>
        {t.privacidad}
      </Link>
      <Link to='/terminos' className='underline hover:text-(--ink)'>
        {t.terminos}
      </Link>
      <Link to='/aviso-legal' className='underline hover:text-(--ink)'>
        {t.aviso}
      </Link>
    </footer>
  );
}
